import { useEffect, useState } from "react";

export default function Footer() {
  const [breath, setBreath] = useState(false);
  useEffect(() => {
    const begin = () => setBreath(true);
    window.addEventListener("prism:drone-begin", begin);
    return () => window.removeEventListener("prism:drone-begin", begin);
  }, []);
  const whisper =
    "inline-flex min-h-[44px] items-center font-sans text-xs tracking-wider text-[#84DFF4]/80 hover:text-[#84DFF4] transition-colors";
  return (
    <footer
      data-testid="site-footer"
      className="px-10 pb-[max(2.5rem,env(safe-area-inset-bottom))] pt-20"
    >
      <div className="mx-auto max-w-4xl">
        <div
          data-testid="footer-hairline"
          data-breathing={breath || undefined}
          onAnimationEnd={() => setBreath(false)}
          className={`mb-12 border-t border-[#0B0B10] ${breath ? "footer-hairline-breath" : ""}`}
        />
        <nav
          data-testid="footer-nav"
          aria-label="Footer"
          className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center sm:text-left max-w-4xl mx-auto mb-10"
        >
          <div data-testid="footer-archives-column" className="flex min-w-0 flex-col items-center sm:items-start">
            <h2 data-testid="footer-archives-heading" className="mb-3 font-mono text-xs tracking-[0.2em] text-[#F5F5F7]/40 uppercase">The archives</h2>
            <a data-testid="footer-link-technology" href="/technology" className={whisper}>Technology</a>
            <a data-testid="footer-link-lab" href="/lab" className={whisper}>Lab records</a>
            <a data-testid="footer-link-films" href="/films" className={whisper}>Videos (2015 → today)</a>
            <a data-testid="footer-link-retrospective" href="/retrospective" className={whisper}>Photographs (2015 → today)</a>
            <a data-testid="footer-link-archive" href="/archive" className={whisper}>The inverse archive</a>
            <a data-testid="footer-link-collaborate" href="/collaborate" className={whisper}>Collaborate</a>
            <a data-testid="footer-document-link" href="/document" className={whisper}>Foundational document</a>
            <a data-testid="footer-link-formulations" href="/formulations" className={whisper}>Formulations</a>
            <a data-testid="footer-link-knowledge" href="/knowledge" className={whisper}>Knowledge</a>
          </div>
          <div data-testid="footer-ecosystem-column" className="flex min-w-0 flex-col items-center sm:items-start">
            <h2 data-testid="footer-ecosystem-heading" className="mb-3 font-mono text-xs tracking-[0.2em] text-[#F5F5F7]/40 uppercase">The ecosystem</h2>
            <a data-testid="footer-link-commons" href="/commons" className={whisper}>The commons</a>
            <a data-testid="footer-link-makers" href="/makers" className={whisper}>Makers</a>
            <a data-testid="footer-link-submit" href="/submit" className={whisper}>Submit</a>
          </div>
          <div data-testid="footer-material-column" className="flex min-w-0 flex-col items-center sm:items-start">
            <h2 data-testid="footer-material-heading" className="mb-3 font-mono text-xs tracking-[0.2em] text-[#F5F5F7]/40 uppercase">The material</h2>
            <a
              data-testid="footer-link-samples"
              href="/samples"
              onClick={(e) => {
                e.preventDefault();
                window.dispatchEvent(new CustomEvent("prism:open-samples"));
              }}
              className={whisper}
            >
              Material samples
            </a>
            <a data-testid="footer-link-shop" href="/patron" className={whisper}>Patron access</a>
            <a
              data-testid="footer-link-topography"
              href="/topography"
              className="inline-flex min-h-[44px] items-center font-mono text-[11px] uppercase tracking-[0.2em] text-[#84DFF4]/70 transition-colors duration-300 hover:text-[#84DFF4]"
            >
              Solar Shadow Forecaster
            </a>
            <a data-testid="footer-social-email" href="mailto:charlie@prismpixelcreators.com" className={whisper}>Email</a>
          </div>
        </nav>
        <div data-testid="footer-attribution" className="text-center font-mono text-[#F5F5F7]/40 text-[11px] tracking-[0.2em] uppercase leading-[2]">
          <p data-testid="footer-powered-by" className="mb-4">
            Powered by <a data-testid="footer-lumen8-link" href="/about" className="inline-flex min-h-[44px] items-center transition-colors hover:text-[#84DFF4]">Lumen8 Laboratories</a>
          </p>
          <p data-testid="footer-brand">Prism Pixel Creators</p>
          <p data-testid="footer-domain">prismpixelcreators.com</p>
          <p data-testid="footer-tagline" className="mt-4">
            A new medium for a new era.
          </p>
        </div>
      </div>
    </footer>
  );
}
